// extracted by mini-css-extract-plugin
export var background = "index-module--background--j84ix";
export var noMask = "index-module--noMask--IHUET";